export const FETCHING_TELECONSEILLERS = 'FETCHING_TELECONSEILLERS';
export const CREATING_TELECONSEILLERS = 'CREATING_TELECONSEILLERS';
export const UPDATING_TELECONSEILLERS = 'UPDATING_TELECONSEILLERS';
export const DELETING_TELECONSEILLERS = 'DELETING_TELECONSEILLERS';

export const UPDATING_TELECONSEILLER_SECURITY_REQUEST = 'UPDATING_TELECONSEILLER_SECURITY_REQUEST';